if (process.env.NODE_ENV === 'production') {
  module.exports = require('./config.prod');
} else if (process.env.NODE_ENV === 'qa') {
  module.exports = require('./config.qa');
} else if (process.env.NODE_ENV === 'local') {
  module.exports = require('./config.local');
} else {
  module.exports = require('./config.dev');
}
